import type { LatLng } from '../../game/geo';

export interface MarkerPair {
  actual: LatLng;
  guess: LatLng | null;
  /** Round number shown on the markers of the summary map. */
  label?: string;
}

export interface MapViewProps {
  initialView: { center: LatLng; zoom: number };
  /** Marker placed by the player (interactive mode). */
  guess?: LatLng | null;
  /** Called when the player clicks the map (interactive mode). */
  onPick?: (position: LatLng) => void;
  /** Result mode: real locations, guesses and the lines between them. */
  pairs?: MarkerPair[];
  /** Changing this value forces the map to recompute its size. */
  resizeKey?: unknown;
  className?: string;
  ariaLabel: string;
}

const GUESS_SVG =
  '<svg viewBox="0 0 32 42" width="32" height="42" aria-hidden="true"><path d="M16 41s13-12.4 13-24A13 13 0 0 0 3 17c0 11.6 13 24 13 24z" fill="var(--pin-guess)" stroke="#fff" stroke-width="2.5"/><circle cx="16" cy="17" r="5" fill="#fff"/></svg>';

const ACTUAL_SVG =
  '<svg viewBox="0 0 32 42" width="32" height="42" aria-hidden="true"><path d="M16 41s13-12.4 13-24A13 13 0 0 0 3 17c0 11.6 13 24 13 24z" fill="var(--pin-actual)" stroke="#fff" stroke-width="2.5"/><path d="M11.5 23V11.5h9l-1.8 3.2 1.8 3.2h-9" fill="#fff"/></svg>';

export function pinHtml(kind: 'guess' | 'actual', label?: string): string {
  const svg = kind === 'guess' ? GUESS_SVG : ACTUAL_SVG;
  const badge = label ? `<span class="map-pin__label">${label}</span>` : '';
  return `<div class="map-pin map-pin--${kind}" title="${kind === 'guess' ? 'Votre réponse' : 'Position réelle'}">${svg}${badge}</div>`;
}

/** Moves `guess` by ±360° of longitude so that the line to `actual` takes the shortest way. */
export function unwrapNear(reference: LatLng, point: LatLng): LatLng {
  let lng = point.lng;
  while (lng - reference.lng > 180) lng -= 360;
  while (lng - reference.lng < -180) lng += 360;
  return { lat: point.lat, lng };
}
